import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc70f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo-circle" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-move-folder" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Re-order photo ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-copy-content" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-copy-content" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _ctx.hidePopUp,
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.title')), 1)
    ]),
    body: _withCtx(() => [
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 0,
            onClick: _ctx.editCase
          }, {
            icon: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.edit.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 1,
            onClick: _ctx.openMovePopUp
          }, {
            icon: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.move.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 2,
            onClick: _ctx.reorderPhoto,
            class: _normalizeClass({ 'disabled-item': _ctx.photoUploading})
          }, {
            icon: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _hoisted_3,
              (_ctx.photoUploading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "- Wait until image(s) uploaded ..."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClick", "class"]))
        : _createCommentVNode("", true),
      (_ctx.actionBar.showSave)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 3,
            onClick: _ctx.saveCaseAsCopy
          }, {
            icon: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.copy.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 4,
            onClick: _ctx.deleteCase
          }, {
            icon: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.delete.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 5,
            onClick: _ctx.openInfoPopUp
          }, {
            icon: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.info.option')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isNetwork && !_ctx.isMy)
        ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
            key: 6,
            onClick: _ctx.removeSharing
          }, {
            icon: _withCtx(() => [
              _hoisted_9
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.remove.sharing')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onHide"]))
}